import { useCallback, useEffect, useRef, useState } from "react";
import { AppSettingsVar } from "../_project/settings";
import { getCookie, csrfSafeMethod } from "../functions/getCookie";
import i18n from "../i18n";

var csrftoken = getCookie('csrftoken');

export const addAuthorization = async (requestObject) => {
    var body = JSON.stringify({'username':AppSettingsVar.user, 'password':AppSettingsVar.password})
    const url_prefix = AppSettingsVar.portal_prefix
    var token_response = await fetch( 
        AppSettingsVar.base_url + url_prefix + 'api-token-auth/' , 
        {   'method':'POST',
            'body':body, 
            'data':body, 
            'headers':{
                'Accept':'application/json',  
                'Content-Type':'application/json',  
                "X-Requested-With":'XMLHttpRequest',
                "X-CSRFToken":csrftoken
            }
        }
    )
    var token = await token_response.json()
    requestObject['headers']['Authorization'] = 'Token ' +  token.token
    return requestObject
}


const useHttp = (applyData,) => {
    
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const pendingRequestsRef = useRef(0);
    const managedControllersRef = useRef(new Set());

    const sendRequest = useCallback(async (requestConfig, additionalArgs = {}) => {
        let managedController = null;
        let signal = requestConfig.signal;

        if (requestConfig.cancelPrevious) {
            managedControllersRef.current.forEach((controller) => controller.abort());
            managedControllersRef.current.clear();
            managedController = new AbortController();
            managedControllersRef.current.add(managedController);
            signal = managedController.signal;
        }

        pendingRequestsRef.current += 1;
        setIsLoading(true);
        setError(null);
        try{
            // const milliseconds = new Date()
            var requestObject = {
                method: requestConfig.method ? requestConfig.method : 'GET',
                headers: requestConfig.headers ? requestConfig.headers : {},
                body: requestConfig.data ? requestConfig.data : null,
            }
            if (requestConfig.signal) {
                requestObject.signal = requestConfig.signal
            }
            if (!csrfSafeMethod(requestConfig.method)) { // && !this.crossDomain
                requestObject['headers']["X-CSRFToken"] = csrftoken;
                requestObject['headers']["X-Requested-With"] = 'XMLHttpRequest';
                requestObject['headers']['Content-Type'] = 'multipart/form-data; boundary=----WebKitFormBoundary';
            }   
            var url = requestConfig.url
            if(AppSettingsVar.debug){
                const check_url = url.replace(AppSettingsVar.base_url, "")
                const int_url = check_url.startsWith("/rest/") || check_url.startsWith(AppSettingsVar.portal_prefix + "statistic/")
                if(int_url){
                    requestObject = await addAuthorization(requestObject)
                }
                if(!url.startsWith('http') && int_url){
                    url = AppSettingsVar.base_url + url
                }
            }
            const response = await fetch(url, requestObject)
            var data = {}
            if(!response.ok){
                if (response.status === 404){
                    const data = await response.json()
                    throw new Error(i18n.t("The requested data could not be found."), {status:response.status});
                    }
                else if(response.status === 500){
                    throw new Error(i18n.t("Something went wrong on the server."), {status:response.status});
                    }
                else if(response.status === 403 ){
                    throw new Error(i18n.t("You're not allowed to access this data"), {status:response.status});
                    }
                else if(response.status===401){
                    throw new Error(i18n.t("It seems you're not logged in or your session has expired. Please log in again."), {status:response.status});
                    }
    
                else{
                    throw new Error(i18n.t("Something went wrong with loading the requested data. Please try again later."), {status:response.status});
                }
            }
            if(requestConfig.json){
                data = await response.json()
            }
            else{
                data = await response.text()
            }
            // if(signal){
            //     data['signal'] = signal
            // }
            applyData(data, additionalArgs)
        } catch(err){
            if (err && err.name === 'AbortError') {
                setIsLoading(false)
                return
            }
            setError(err || 'Something went wrong!')
        } finally {
            if (managedController) {
                managedControllersRef.current.delete(managedController);
            }
            pendingRequestsRef.current = Math.max(0, pendingRequestsRef.current - 1);
            setIsLoading(pendingRequestsRef.current > 0)
        }
    }, [applyData])

    useEffect(() => {
        return () => {
            managedControllersRef.current.forEach((controller) => controller.abort());
            managedControllersRef.current.clear();
        };
    }, []);

    return {
         isLoading
        ,error
        ,sendRequest
    }

}

export default useHttp